import styled from 'styled-components';

export const LoaderOverlay = styled.div`
  position: fixed;
  background: rgba(255, 255, 255, 0.7);
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;
